<template>
  <div class="contain">
    <!-- 검색 조건 -->
    <div class="search_form" ref="search_form">
      <el-form
        :inline="true"
        :model="searchForm"
        :label-position="`left`"
        label-suffix=":"
        :size="size"
        @submit.native.prevent>
        <el-row>
          <el-col :sm="8">
            <el-form-item :label="$t('언어')">
              <el-input v-model="searchForm.nm" @keyup.enter.native="search" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="8">
            <el-form-item :label="$t('타입')">
              <code-combo
                :data="dictionaryTp"
                :label="$t('전체')"
                :model="searchForm.dictionaryTpCd"
                @change="searchForm.dictionaryTpCd = $event.cd"></code-combo>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <!-- 버튼-->
    <div class="buttons" ref="buttons">
      <el-button v-if="checkAuthActionAccess('DictionarySearch')" :size="size" @click="search" icon="el-icon-search">{{
        $t('검색')
      }}</el-button>
      <el-button
        v-if="checkAuthActionAccess('DictionaryAdd')"
        :size="size"
        @click="add"
        icon="el-icon-circle-plus-outline"
        :disabled="btn.addDisabled"
        >{{ $t('등록') }}</el-button
      >
      <el-button
        v-if="checkAuthActionAccess('DictionaryUp')"
        :size="size"
        @click="up"
        icon="el-icon-edit-outline"
        :disabled="btn.upDisabled"
        >{{ $t('수정') }}</el-button
      >
      <el-button
        v-if="checkAuthActionAccess('DictionaryDown')"
        :size="size"
        @click="downExcel"
        icon="el-icon-download"
        >{{ $t('출력') }}</el-button
      >

      <el-upload
        v-if="checkAuthActionAccess('DictionaryDown')"
        :show-file-list="false"
        :action="`${APP_API_URL}/dictionary/up`"
        with-credentials
        accept="application/vnd.ms-excel"
        :headers="uploadHeaders"
        style="display: inline; margin-left: 10px"
        :on-success="upSuccess"
        :on-error="upError">
        <el-button :size="size" icon="el-icon-upload">{{ $t('업로드') }}</el-button>
      </el-upload>

      <el-button
        v-if="checkAuthActionAccess('DictionaryAdd') || checkAuthActionAccess('DictionaryUp')"
        :size="size"
        @click="save"
        icon="el-icon-check"
        :disabled="btn.saveDisabled"
        style="float: right"
        class="hide-on-mobile"
        >{{ $t('저장') }}</el-button
      >
    </div>

    <!-- 리스트 -->
    <el-row :gutter="20">
      <el-col :md="16">
        <el-table
          :height="tableHeight"
          ref="table"
          border
          stripe
          highlight-current-row
          tooltip-effect="dark"
          :data="tableData"
          :size="size"
          :empty-text="$t('데이타 없음')"
          @row-click="handleRowClick">
          <el-table-column
            :label="tableData.length.toString()"
            type="index"
            width="55"
            align="center"
            label-class-name="data_cnt"></el-table-column>
          <el-table-column
            :label="$t('언어 코드')"
            prop="id"
            min-width="200"
            sortable
            show-overflow-tooltip></el-table-column>
          <el-table-column
            :label="$t('타입')"
            prop="dictionaryTp.nmLan"
            min-width="120"
            align="center"
            sortable
            show-overflow-tooltip></el-table-column>
          <el-table-column
            v-for="item in lans"
            :key="item.id"
            :label="item.nm"
            :prop="item.id"
            min-width="200"
            sortable
            show-overflow-tooltip></el-table-column>
        </el-table>
      </el-col>
      <el-col :md="8">
        <el-card shadow="never" :style="{ height: inputHeight + 'px' }" class="input-menu">
          <div slot="header">
            <span>{{ $t('언어') }}</span>
            <span v-if="'I' == inputForm.statu">{{ $t('추가') }}</span>
            <span v-if="'U' == inputForm.statu">{{ $t('수정') }}</span>
          </div>
          <div>
            <el-form
              :model="inputForm"
              :label-width="$device.mobile ? `` : `120px`"
              label-suffix=":"
              :size="size"
              :disabled="fromDisabled"
              @submit.native.prevent>
              <el-form-item :label="$t('언어 코드')" :error="formError.id" required>
                <template v-if="'I' === inputForm.statu">
                  <el-input v-model="inputForm.id" maxlength="250" show-word-limit clearable>
                    <el-button slot="append" :size="size" @click="showDataSearchPop" icon="el-icon-search">{{
                      $t('키워드 조회')
                    }}</el-button>
                  </el-input>
                </template>

                <span v-else class="show_cd">{{ inputForm.id }}</span>
              </el-form-item>

              <el-form-item :label="$t('타입')" :error="formError['dictionaryTp.cd']" required>
                <code-combo
                  :data="dictionaryTp"
                  :model="inputForm.dictionaryTp"
                  @change="inputForm.dictionaryTp = $event"></code-combo>
              </el-form-item>

              <el-form-item :label="$t('한국어')" :error="formError.nm" required>
                <el-input v-model="inputForm.nm" type="textarea" maxlength="250" show-word-limit></el-input>
              </el-form-item>
              <el-form-item v-for="item in inputForm.dictionarys" :label="item.lan.nm" :key="item.lan.id">
                <el-input v-model="item.nm" type="textarea" maxlength="250" show-word-limit></el-input>
              </el-form-item>
            </el-form>

            <el-button
              v-if="checkAuthActionAccess('DictionaryAdd') || checkAuthActionAccess('DictionaryUp')"
              :size="size"
              @click="save"
              icon="el-icon-check"
              :disabled="btn.saveDisabled"
              style="float: right"
              class="hide-on-desktop"
              >{{ $t('저장') }}</el-button
            >
          </div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 키워드 조회 팝업 -->
    <el-dialog :title="$t('키워드 조회')" :visible.sync="dialogFormVisible" width="900px">
      <!-- 검색 조건 -->
      <div class="search_form" ref="search_form" style="margin-bottom: 10px">
        <el-form :inline="true" label-width="60px" label-suffix=":" :size="size" @submit.native.prevent>
          <el-row>
            <el-col :span="8">
              <el-form-item :label="$t('타입')">
                <code-combo
                  :data="dictionaryTp"
                  :label="$t('전체')"
                  :model="searchDictionaryTpCd"
                  @change="searchDictionaryTpCd = $event.cd"></code-combo>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item :label="$t('언어')">
                <el-input v-model="searchText" @keyup.enter.native="search" clearable style="width: 180%">
                  <el-button slot="append" :size="size" @click="dataSearch" icon="el-icon-search">{{
                    $t('검색')
                  }}</el-button>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <el-table
        :height="tableHeight"
        ref="table"
        border
        stripe
        highlight-current-row
        tooltip-effect="dark"
        :data="popTableData"
        :size="size"
        :empty-text="$t('데이타 없음')">
        <el-table-column
          :label="popTableData.length"
          type="index"
          width="55"
          align="center"
          label-class-name="data_cnt"
          :fixed="!$device.mobile"></el-table-column>

        <el-table-column fixed>
          <template slot-scope="scope">
            <el-button :size="size" @click="handleSelect(scope.row)">{{ $t('선택') }}</el-button>
          </template>
        </el-table-column>

        <el-table-column
          :label="$t('언어 코드')"
          prop="id"
          min-width="200"
          sortable
          show-overflow-tooltip></el-table-column>
        <el-table-column
          v-for="item in lans"
          :key="item.id"
          :label="item.nm"
          :prop="item.id"
          min-width="200"
          sortable
          show-overflow-tooltip></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import { util } from '@/mixins/utilMixin'
import { checkAuthActionAccess } from '@/utils/checkAuthActionAccess'
import { APP_API_URL, initData } from '@/utils/constants'
import { downloadExcelFile } from '@/utils/downloadExcelFile'
import { mapGetters } from 'vuex'

export default {
  data() {
    const data = initData()

    data.APP_API_URL = APP_API_URL

    data.url = '/dictionary'

    data.lans = []
    data.dictionaryTp = []

    data.searchForm = this.initSearchForm()
    data.inputForm = this.initInputForm()
    data.formError = this.initFormError()

    data.popTableData = []
    data.dialogFormVisible = false
    data.searchDictionaryTpCd = 0
    data.searchText = ''

    return data
  },
  computed: {
    ...mapGetters({
      tableHeight: 'ui/tableHeight',
      inputHeight: 'ui/inputHeight',
      // 직접 업로드(`el-upload`)가 싣는 CSRF 헤더 — 스토어가 지금 토큰에서 셈한다(서버가 받는 이름 한 곳)
      uploadHeaders: 'auth/csrfHeaders',
    }),
  },
  created: async function () {
    this.initLan()
    this.initDictionaryTp()
    this.search()
  },
  mounted: async function () {
    setTimeout(
      function () {
        this.$nextTick(
          function () {
            // this.mainVue.currVue = this
          }.bind(this)
        )
      }.bind(this),
      1000
    )
  },
  watch: {
    'inputForm.id': function (newVal, oldVal) {
      if ('' != newVal && 'I' === this.inputForm.statu) {
        this.chkDictionaryId()
      }
    },
  },
  methods: {
    checkAuthActionAccess,
    // 검색 조건 초기화
    initSearchForm: function () {
      return {
        nm: '',
        dictionaryTpCd: 0,
      }
    },
    // 입력폼 초기화
    initInputForm: function () {
      var obj = {
        statu: 'I',
        cd: 0,
        id: '',
        nm: '',
        useYn: 'Y',
        lan: null,
        dictionaryTp: { cd: null, nm: '' },
        dictionarys: [],
      }

      if (null != this.lans) {
        // 기타 언어 변수 설정
        for (var i = 0, len = this.lans.length; i < len; i++) {
          if ('ko' == this.lans[i].id) {
            obj.lan = this.lans[i]
          } else {
            obj.dictionarys.push({
              cd: 0,
              id: '',
              nm: '',
              useYn: 'Y',
              lan: this.lans[i],
              dictionaryTp: { cd: null, nm: '' },
            })
          }
        }
      }

      return obj
    },
    // 오류 메세지 초기화
    initFormError: function () {
      return {
        id: '',
        nm: '',
        'dictionaryTp.cd': '',
      }
    },
    // 그리드 선택 이벤트
    handleRowClick: function (val) {
      if (null != val) {
        this.btn.upDisabled = false
      }
      this.selectData = val
    },
    // 언어 데이타 조회
    initLan: async function () {
      const result = await this.$axios.get('/language').then((res) => res.data)

      this.lans = result
    },
    // 단말 타입 데이타 조회
    initDictionaryTp: async function () {
      const result = await this.$axios.get('/code/getCode/DICTIONARY_TP').then((res) => res.data)

      this.dictionaryTp = result
    },
    // 추가
    add: async function () {
      this.inputForm = this.initInputForm()
      // 단말 타입 처음 항목 설정
      this.inputForm.dictionaryTp =
        this.dictionaryTp.length > 0 ? util.copyObj(this.dictionaryTp[0]) : { cd: null, nm: '' }
      for (var i = 0, len = this.inputForm.dictionarys.length; i < len; i++) {
        this.inputForm.dictionarys[i].dictionaryTp =
          this.dictionaryTp.length > 0 ? util.copyObj(this.dictionaryTp[0]) : { cd: null, nm: '' }
      }

      this.formError = this.initFormError()

      this.btn.saveDisabled = false
      this.fromDisabled = false
    },
    // 수정
    up: async function () {
      const result = await this.$axios.get(this.url + '/' + this.selectData.cd).then((res) => res.data)

      result.statu = 'U'

      this.inputForm = result

      // 수정 시 등록되지 안은 기타 언어 변수 설정
      for (var i = 0, len = this.lans.length; i < len; i++) {
        if ('ko' != this.lans[i].id) {
          var isContains = false

          for (var j = 0, jlen = this.inputForm.dictionarys.length; j < jlen; j++) {
            if (this.inputForm.dictionarys[j].lan.id === this.lans[i].id) {
              isContains = true
            }
          }

          if (!isContains) {
            this.inputForm.dictionarys.push({
              cd: 0,
              id: this.inputForm.id,
              nm: this.inputForm.id,
              useYn: 'Y',
              lan: this.lans[i],
              dictionaryTp: this.inputForm.dictionaryTp,
            })
          }
        }
      }

      this.formError = this.initFormError()

      this.btn.saveDisabled = false
      this.fromDisabled = false
    },
    // 조회
    search: async function () {
      const result = await this.$axios.get(this.url, { params: this.searchForm }).then((res) => res.data)

      this.tableData = []

      for (var i = 0, len = result.length; i < len; i++) {
        var tmp = result[i]

        tmp[result[i].lan.id] = result[i].nm

        for (var j = 0, jlen = result[i].dictionarys.length; j < jlen; j++) {
          tmp[result[i].dictionarys[j].lan.id] = result[i].dictionarys[j].nm
        }

        this.tableData.push(tmp)
      }

      this.btn.addDisabled = false
      this.btn.upDisabled = true
      this.btn.saveDisabled = true
      this.fromDisabled = true

      this.inputForm = this.initInputForm()
      this.formError = this.initFormError()
    },
    // 저장
    save: async function () {
      this.formError = this.initFormError()

      var tmpInput = {
        cd: this.inputForm.cd,
        id: this.inputForm.id,
        nm: this.inputForm.nm,
        useYn: this.inputForm.useYn,
        lan: this.inputForm.lan,
        dictionaryTp: this.inputForm.dictionaryTp,
        dictionarys: [],
      }

      // 입력되지 안은 언어 삭제
      for (var i = 0, len = this.inputForm.dictionarys.length; i < len; i++) {
        if ('' != this.inputForm.dictionarys[i].nm) {
          // 언어 코드 기타 언어에도 똑같이 설정
          this.inputForm.dictionarys[i].id = this.inputForm.id
          this.inputForm.dictionarys[i].dictionaryTp = this.inputForm.dictionaryTp
          tmpInput.dictionarys[tmpInput.dictionarys.length] = this.inputForm.dictionarys[i]
        }
      }

      if ('I' === this.inputForm.statu) {
        await this.$axios.post(this.url, tmpInput)

        this.$message({ type: 'success', message: this.$t('등록 성공') })
        // this.mainVue.$message({ type: 'success', message: this.$t('등록 성공') })
        this.search()
      } else {
        try {
          await this.$axios.put(this.url + '/' + this.inputForm.cd, tmpInput)

          this.$message({ type: 'success', message: this.$t('수정 성공') })
          // this.mainVue.$message({ type: 'success', message: this.$t('수정 성공') })
          this.search()
        } catch (error) {
          this.formError
        }
      }
    },
    chkDictionaryId: async function () {
      // 서버에서 한국어 기준으로 체크 함
      // @TODO with out loading
      const result = await this.$axios.patch(this.url + '/chk/' + encodeURI(this.inputForm.id)).then((res) => res.data)

      if (!result.data) {
        this.formError.id = ''
        this.btn.saveDisabled = false
      } else {
        this.formError.id = this.$t('이미 사용중인 언어 코드입니다.')
        this.btn.saveDisabled = true
      }
    },
    downExcel: async function () {
      const url = this.url + '/down?nm=' + this.searchForm.nm

      downloadExcelFile(url)
    },
    upSuccess: async function () {
      this.$message({ type: 'success', message: this.$t('업로드 되었습니다') })
      // this.mainVue.$message({ type: 'success', message: this.$t('업로드 되었습니다') })
      this.search()
    },
    upError: async function () {
      this.$message({ type: 'error', message: this.$t('업로드 실패 하였습니다') })
      // this.mainVue.$message({ type: 'error', message: this.$t('업로드 실패 하였습니다') })
    },
    // 등록된 키워드 조회 팝업
    showDataSearchPop: async function () {
      this.dialogFormVisible = true
      this.dataSearch()
    },
    // 키워드 데이타 조회
    dataSearch: async function () {
      const result = await this.$axios
        .get(this.url + '/searchText', {
          params: { searchText: this.searchText, dictionaryTpCd: this.searchDictionaryTpCd },
        })
        .then((res) => res.data)

      this.popTableData = []

      for (var i = 0, len = result.length; i < len; i++) {
        var tmp = result[i]

        tmp[result[i].lan.id] = result[i].nm

        for (var j = 0, jlen = result[i].dictionarys.length; j < jlen; j++) {
          tmp[result[i].dictionarys[j].lan.id] = result[i].dictionarys[j].nm
        }

        this.popTableData.push(tmp)
      }
    },
    // 키워드 데이타 선택
    handleSelect: function (row) {
      this.inputForm.id = row.id
      this.inputForm.nm = row.nm
      this.inputForm.dictionaryTp = row.dictionaryTp

      // 등록 안된 언어가 있으면 기본 언어로 값을 설정 해줌
      for (var i = 0, len = this.lans.length; i < len; i++) {
        if (this.lans[i].id != row.lan.id) {
          var isExist = false

          for (var j = 0, jlen = row.dictionarys.length; j < jlen; j++) {
            if (this.lans[i].id == row.dictionarys[j].lan.id) {
              isExist = true
              break
            }
          }

          if (!isExist) {
            row.dictionarys.splice(i, 0, {
              id: row.id,
              nm: row.nm,
              dictionaryTp: row.dictionaryTp,
              lan: this.lans[i],
              useYn: 'Y',
            })
          }
        }
      }

      this.inputForm.dictionarys = row.dictionarys
      this.dialogFormVisible = false
    },
  },
}
</script>
